import React from "react";
import { Link } from "react-router-dom";

import styles from "./footer.module.scss";
import logo from "@/assets/img/logo.svg";

import { FooterMenuItemsType } from "./types";

import whatsAppIcon from "@/assets/icons/whatsAppFooter.svg";
import telegramIcon from "@/assets/icons/telegramFooter.svg";

const footerMenuItems: FooterMenuItemsType = [
  { id: "rentCourts", name: "Аренда кортов", href: "/" },
  { id: "services", name: "Сервис", href: "/services" },
  { id: "school", name: "Школа тенниса", href: "/services/tennis-school" },
  { id: "about", name: "Правила клуба", href: "/rules" },
  { id: "about", name: "О клубе", href: "/about" },
  { id: "contacts", name: "Контакты", href: "/contacts" },
];

export const Footer: React.FC = () => {
  const footerMenu = renderFooterMenu(footerMenuItems);

  function renderFooterMenu(menuItems: FooterMenuItemsType) {
    return menuItems.map(({ id, name, href }) => (
      <li key={id}>
        <Link  to={href}>{name}</Link>
      </li>
    ));
  }

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.logo}>
            <Link to="/">
              <img src={logo} alt="Company's logo" />
            </Link>
            <Link to="/privacy-policy">
              Политика конфиденциальности
            </Link>
          </div>

          <nav className={styles.menu}>
            <ul className={styles.menu__list}>
              {footerMenu}
            </ul>
          </nav>

          <div className={styles.contacts}>
            <div className={styles.contacts__icons}>
              <a href="https://wa.me/+79035564444?text=Привет!" target="_blank" rel="noreferrer">
                <img src={whatsAppIcon} alt="whatsApp icon" />
              </a>
              <a href="https://t.me/+79035564444" target="_blank" rel="noreferrer">
                <img src={telegramIcon} alt="telegram icon" />
              </a>
            </div>
            <p className={styles.phone}>
              <a  href={'tel: +7 (495) 150-55-99'}>+7 (495) 150-55-99</a>
            </p>
            <p className={styles.address}>
              <a target="_blank" href={'https://yandex.ru/maps/213/moscow/house/malaya_letovskaya_ulitsa_8/Z04YcgZgSUwAQFtvfXl2cX1gZQ==/?ll=37.410097%2C55.570131&z=17.1'} rel="noreferrer">г. Москва, ул. Летовская Малая, 8</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
